<template>
    <div class="stripe-input-wrapper">
        <LoadingAnimation
            v-if="isStatusLoading"
            class="w-100 d-flex align-items-center"
            style="height: 55px"
            animation-style="bars"
        ></LoadingAnimation>

        <form id="payment-form" style="width: 100%">
            <div id="payment-element">
                <!-- Elements will create form elements here -->
            </div>
            <div v-if="cardError" class="stripe-error-container text-danger mt-1">{{ cardError }}</div>
            <div class="justify-content-center d-flex align-items-center text-muted font-size-75 mt-1">
                <i class="mr-1 fa fa-lock"></i> {{ 'All transactions are SSL encrypted.' | trans }}
            </div>
        </form>
    </div>
</template>

<script>
import { pageNotification } from '../../../../../qaamgo/helper/notify';
import { globalLogger } from '../../../../../qaamgo/helper/global-logger';
import DataStatus from '../../../../../qaamgo/modules/sat/components/mixins/DataStatus';
import LoadingAnimation from '../../../../../qaamgo/modules/sat/components/LoadingAnimation';
import Tooltip from '../../../../../qaamgo/modules/sat/components/form/Tooltip';
import TransFilter from '../../../../../qaamgo/modules/sat/components/mixins/TransFilter';
import { stripeHelper } from '../../../../payment/stripe-helper';
import { testIsNonEmptyString } from '../../../../../lib/test-and-assert/test-base';
import { satGlobals } from '../../../../../qaamgo/sat/helper/sat-globals';
import { translatePath } from '../../../../../qaamgo/sat/helper/translate-path';

let stripeApiLoadingPromise = null;

export default {
    name: 'CreditCardStripe',
    components: { Tooltip, LoadingAnimation },
    mixins: [DataStatus, TransFilter],
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        stripePaymentIntent: {
            type: String,
            default: '',
        },
    },
    beforeMount() {
        stripeApiLoadingPromise = new Promise((resolve, reject) => {
            // delay stripe form rendering to avoid performance issues on initial render
            setTimeout(() => {
                stripeHelper.initializeStripe().then(resolve).catch(reject);
            }, 500);
        });
    },
    mounted() {
        // only unblock once stripe api is loaded and initialized
        stripeApiLoadingPromise
            .then(() => {
                const options = {
                    clientSecret: this.stripePaymentIntent,
                    // Fully customizable with appearance API.
                    appearance: {
                        variables: {
                            colorText: '#2e2e2e',
                            fontFamily: 'Open Sans,Helvetica,Arial,sans-serif',
                            borderRadius: '8px',
                        },
                    },
                };

                this.stripe = stripeHelper.getStripe();
                this.stripeElements = this.stripe.elements(options);

                const paymentElement = this.stripeElements.create('payment');
                paymentElement.mount('#payment-element');

                this.setStatusDone();
            })
            .catch((e) => {
                pageNotification.showGenericErrorMessage();
                globalLogger.log('stripe vue - error loading stripe api', e);
            });
    },
    methods: {
        hasErrors() {
            return testIsNonEmptyString(this.cardError);
        },
        setErrorMessage(message) {
            this.cardError = message;
        },
        confirmStripePayment(isSubscription) {
            // make sure users don't have to confirm that they want to be redirected
            window.allowLeave = true;

            let returnUrl = satGlobals.getAccountUrl() + '/register/stripe/order/finish';

            if (isSubscription) {
              returnUrl += '?isSubscription=true'
            }

            return this.stripe
                .confirmPayment({
                    elements: this.stripeElements,
                    confirmParams: {
                        return_url: returnUrl,
                    },
                })
                .then(function (result) {
                    // This point will only be reached if there is an immediate error when
                    // confirming the payment. Otherwise, your customer will be redirected to
                    // your `return_url`. For some payment methods like iDEAL, your customer will
                    // be redirected to an intermediate site first to authorize the payment, then
                    // redirected to the `return_url`.

                    if (result.error) {
                        return Promise.reject(result.error);
                    }

                    return result;
                });
        },
    },
    data() {
        return {
            stripe: null,
            stripeElements: null,
            cardError: '',
        };
    },
};
</script>

<style lang="scss">
@import '../../../../../../../../../../../node_modules/sass-material-colors/sass/sass-material-colors';

@import '../../../../../../scss/abstracts/mixins';
@import '../../../../../../scss/abstracts/functions';
@import '../../../../../../scss/abstracts/variables';
@import '../../../../../../../../../../../assets/scss/abstracts/variables';

@import '../../../../../../../../../../../node_modules/bootstrap/scss/functions';
@import '../../../../../../../../../../../node_modules/bootstrap/scss/variables';
@import '../../../../../../../../../../../node_modules/bootstrap/scss/mixins';

.StripeElement--invalid,
.StripeElement.invalid {
    border-color: $danger !important;
}

.StripeElement {
    padding: 1rem;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    background: white;
}
</style>
